import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { getServerURL } from "../utils/funcs/get-serverURL";
import styles from "../styles/remedial-quote.module.scss";

type BookingSummary = {
  customerName: string;
  customerEmail: string;
  totalAmount: number;
  scheduledDate: string;
  timeSlot: string;
  status: string;
};

export default function RemedialCheckoutSuccessPage() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id") || "";
  const serverURL = getServerURL();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [booking, setBooking] = useState<BookingSummary | null>(null);
  const [pollCount, setPollCount] = useState(0);

  useEffect(() => {
    const fetchBooking = async () => {
      if (!sessionId) {
        setError("Missing checkout session id");
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(`${serverURL}/remedial-bookings/session/${sessionId}/public`);
        if (response.data?.success) {
          setBooking(response.data.booking);
          
          // If booking is still in checkout_created status and we haven't polled too many times, retry after delay
          if (response.data.booking?.status === 'checkout_created' && pollCount < 10) {
            setTimeout(() => {
              setPollCount(pollCount + 1);
              fetchBooking();
            }, 1000); // Retry after 1 second
          } else {
            setLoading(false);
          }
        } else {
          setError("Unable to verify payment result");
          setLoading(false);
        }
      } catch (err: any) {
        setError(err?.response?.data?.error || "Unable to verify payment result");
        setLoading(false);
      }
    };

    fetchBooking();
  }, [sessionId, serverURL]);

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h1 className={styles.title}>Payment Received</h1>
        {loading ? <p>Loading confirmation...</p> : null}
        {!loading && error ? <div className={styles.alertError}>{error}</div> : null}

        {!loading && booking ? (
          <>
            <p className={styles.subtitle}>Thank you. Your remedial works booking is confirmed.</p>
            <div className={styles.meta}>
              <div><strong>Name:</strong> {booking.customerName}</div>
              <div><strong>Email:</strong> {booking.customerEmail}</div>
              <div><strong>Total paid:</strong> £{Number(booking.totalAmount || 0).toFixed(2)}</div>
              <div><strong>Date:</strong> {booking.scheduledDate}</div>
              <div><strong>Time slot:</strong> {booking.timeSlot}</div>
              <div><strong>Status:</strong> {booking.status}</div>
            </div>
            <p>
              We have added this booking to our calendar and will contact you if we need anything else.
            </p>
          </>
        ) : null}

        <p>
          <Link className={styles.link} to="/contact-us">Contact Teck Engineers</Link>
        </p>
      </div>
    </div>
  );
}
